<template>
  <div>
    <page-header :title="$store.state.AppActiveUser.userRole === 'fc-operations-supervisor' ? $t('Outbound Orders') : $t('Fulfillment Orders')">
    <div v-if="$store.state.AppActiveUser.userRole !== 'fc-operations-supervisor'">
      <vs-dropdown
        vs-trigger-click
        class="dropdown dd-actions cursor-pointer mr-4 "
      >
        <vs-button
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          size="large"
        >
        </vs-button>
        <vs-dropdown-menu class="add-shipment-dropdown">
          <vs-dropdown-item @click="openProductModal('New Product')">
            <span class="flex items-center">
              <feather-icon
                icon="PackageIcon"
                svgClasses="h-4 w-4"
                class="mr-2"
              />
              <span>{{$t('New Outbound Order')}}</span>
            </span>
          </vs-dropdown-item>
          <vs-dropdown-item @click="openMultipleOrdersUploadPage()">
            <span class="flex items-center">
              <feather-icon
                icon="UploadIcon"
                svgClasses="h-4 w-4"
                class="mr-2"
              />
              <span>{{$t('Multiple Orders')}}</span>
            </span>
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    </page-header>
    
    <orders-table type="outbound" :orderModal="orderModal" @orderModal="orderModal = $event"/>
    <upload-fulfillment-orders-modal v-if="openUploadModal" :uploadShipmentsModal.sync="openUploadModal" @close="openUploadModal = false"/>
  </div>
</template>

<script>
import OrdersTable from './components/OrdersTable.vue'
import UploadFulfillmentOrdersModal from './components/UploadFulfillmentOrdersModal.vue'

export default {
  data () {
    return {
      orderModal: false,
      order: {
        flags: [],
        customer: {
          address: {}
        }
      },
      openUploadModal: false
    }
  },
  methods: {
    openProductModal () {
      this.orderModal = true
    },
    openMultipleOrdersUploadPage () {
      this.$router.push({ name: 'upload-fulfillment-orders' })
    },
    openUploadFulfillmentOrders () {
      this.openUploadModa = true
    }
  },
  components: {
    OrdersTable,
    UploadFulfillmentOrdersModal
  }
}
</script>